import { Component, computed, inject, input } from "@angular/core";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { PermissionActionDescriptorType } from "../../../../../adaa-types";
import { Constants } from "../../../constants/constants";
import { PermissionAction } from "../../../constants/enums";
import { HasPermissionDirective } from "../../../directives";
import type { SelectedPeriodModelType } from "../../../models";
import { PermissionsService, UaeVisionPerfService } from "../../../services";
import { DoughnutComponent } from "../../charts";
import { ItemSliderComponent } from "../item-slider/item-slider";
import { UaeVisionPerfCardComponent } from "../uae-vision-perf-card/uae-vision-perf-card";

@Component({
  selector: "adaa-uae-vision-performance",
  templateUrl: "./uae-vision-performance.html",
  styleUrl: "./uae-vision-performance.scss",
  imports: [DoughnutComponent, TranslatePipe, UaeVisionPerfCardComponent, ItemSliderComponent, HasPermissionDirective],
})
export class UaeVisionPerformanceComponent {
  readonly router = inject(Router);
  private readonly _uaeVisionPerfService = inject(UaeVisionPerfService);
  private readonly _permissionsService = inject(PermissionsService);

  selectedPeriod = input<SelectedPeriodModelType>();

  visionDirections = computed(() => this._uaeVisionPerfService.visionDirections());

  subGovVisionDirections = computed(() => {
    if (this.visionDirections()?.length) {
      return this.visionDirections()[0].subGovDirections;
    }
    return [];
  });

  overallPerformance = computed(() => {
    if (!this.visionDirections()?.length) return undefined;
    return this.visionDirections()[0];
  });

  periodLabel = computed(() => {
    const period = this.selectedPeriod();
    if (!period) return "";
    return period?.type === "year" ? period?.period.year : `Q${period?.period.quarter} ` + period?.period.year;
  });

  showOverall = computed(() => {
    if (!this.overallPerformance()) return false;

    const { permissions, modifier } = this.performancePermission.actor;
    return this._permissionsService.hasPermission(permissions, modifier);
  });

  public get overallPerfColor() {
    return Constants.CONSTANT_COLORS.EVALUATION_GOLD;
  }

  readonly performancePermission: PermissionActionDescriptorType = {
    actor: {
      modifier: "or",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.PMO_HOMEPAGE_WTUAE_PERFORMANCE,
        },
      ],
    },
  };

  readonly pillarPermission: PermissionActionDescriptorType = {
    actor: {
      modifier: "or",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.PMO_HOMEPAGE_WTUAE_PILLARS,
        },
      ],
    },
  };

  public goToNationalTargets() {
    this.router.navigateByUrl("/console/kpi/ntkpi");
  }

  public goToPillar(id: number | undefined) {
    this.router.navigateByUrl(`/console/kpi/ntkpi?sub_gov_direction_id=${id}`);
  }
}
